import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { formatNumber } from './shared/chartFormat';

const BAR_COLOR = '#5eb767';

// PE-438: top branches in range from /hospital_charts, as a plain CSS bar
// list — name, count and a slim progress track per row.
export default class AppointmentTopHospitalsChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: [], loading: true, error: false };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.query !== this.props.query) this.fetchData();
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  fetchData() {
    const requestId = (this.requestId = (this.requestId || 0) + 1);
    this.setState({ loading: true, error: false });

    fetch('/api/appointments/hospital_charts' + (this.props.query || ''))
      .then(res => (res.ok ? res.json() : Promise.reject(res)))
      .then(data => {
        if (this.unmounted || requestId !== this.requestId) return;
        this.setState({ data: Array.isArray(data) ? data : [], loading: false });
      })
      .catch(() => {
        if (this.unmounted || requestId !== this.requestId) return;
        this.setState({ data: [], loading: false, error: true });
      });
  }

  render() {
    const { labels, locale } = this.props;
    const { data, loading, error } = this.state;

    if (loading) {
      return (
        <div style={{ padding: '12px 0' }}>
          <Skeleton count={6} height={30} borderRadius={8} />
        </div>
      );
    }
    if (error) return <div className="text-center text-muted py-5">{labels.load_error}</div>;
    if (!data.length) return <div className="text-center text-muted py-5">{labels.no_data}</div>;

    const max = data.reduce((top, row) => Math.max(top, row.value), 0);

    return (
      <div className="appt-stats__branches">
        {data.map(row => (
          <div className="appt-stats__branch" key={row.id}>
            <div className="appt-stats__branch-head">
              <span className="appt-stats__branch-name">{row.label}</span>
              <span className="appt-stats__branch-value">{formatNumber(row.value, locale)}</span>
            </div>
            <div className="appt-stats__branch-track">
              <div
                className="appt-stats__branch-fill"
                style={{ width: `${max > 0 ? (row.value / max) * 100 : 0}%`, background: BAR_COLOR }}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }
}
